import {
	type FC,
	type HTMLAttributes,
	type PropsWithChildren,
	useId,
} from "react";
import "./Checkbox.css";
import cn from "classnames";

type Props = PropsWithChildren<{
	value: boolean;
	id?: string;
	name?: string;
	className?: string;
	dash?: boolean;
	inputProps?: Omit<
		HTMLAttributes<HTMLInputElement>,
		"value" | "onChange" | "defaultValue" | "checked" | "id"
	>;
	labelProps?: Omit<HTMLAttributes<HTMLLabelElement>, "htmlFor" | "children">;
	onChange?: () => void;
	onDashClick?: () => void;
}>;

const Checkbox: FC<Readonly<Props>> = ({
	children,
	value,
	id,
	name,
	className,
	dash,
	inputProps,
	labelProps,
	onChange,
	onDashClick,
}) => {
	const idLocal = useId();
	return (
		<div className={cn("checkbox", className, { dash }, { active: value })}>
			<input
				{...inputProps}
				onChange={dash ? onDashClick : onChange}
				tabIndex={-1}
				type="checkbox"
				id={id ?? idLocal}
				name={name}
				checked={value}
			/>
			<label
				/* biome-ignore lint/a11y/noNoninteractiveTabindex: Label is used to click the hidden checkbox and the default browser functionality is to focus the input element */
				/* biome-ignore lint/a11y/noNoninteractiveElementToInteractiveRole: ^ */
				/* biome-ignore lint/a11y/useSemanticElements: ^ */
				/* biome-ignore lint/a11y/useAriaPropsForRole: ^ */
				tabIndex={0}
				onKeyDown={(e) => {
					if (["Enter", " "].includes(e.key)) {
						e.preventDefault();
						if (dash) {
							onDashClick?.();
							return;
						}
						onChange?.();
					}
				}}
				{...labelProps}
				htmlFor={id ?? idLocal}
			>
				{children}
			</label>
		</div>
	);
};

export default Checkbox;
